import { getIncludedResource } from '../util';
import { IDocument } from '../models';

export function fromJsonApi(data, included: any[]): IDocument {
  return {
    id: data.id,
    name: data.attributes.name,
    filePath: data.attributes.file_path,
    shortName: data.attributes.short_name,
    displayName: data.attributes.display_name,
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/data/api/transformers/documents.ts